import api from './api';
import type { Message, ChatListItem, NotificationCountResponse } from '@app-types/models/chat';

export const sendMessage = async (formData: FormData): Promise<Message> => {
  try {
    const response = await api.post<Message>(`/chat/send-message`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: unknown) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const getMessages = async (userId: string, staffId?: string): Promise<Message[]> => {
  try {
    const url = staffId ? `/chat/messages/${userId}?staffId=${staffId}` : `/chat/messages/${userId}`;
    const response = await api.get<Message[]>(url);
    console.log('Fetched messages:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

export const getChatList = async (): Promise<ChatListItem[]> => {
  try {
    const response = await api.get<ChatListItem[]>(`/chat/chat-list`);
    console.log('Fetched chat list:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching chat list:', error);
    throw error;
  }
};

export const markMessageAsRead = async (userId: string): Promise<unknown> => {
  try {
    const response = await api.post<unknown>(`/chat/mark-messages-as-read/${userId}`);
    return response.data;
  } catch (error: unknown) {
    console.error('Error marking message as read:', error);
    throw error;
  }
};

export const getAllNotificationCount = async (): Promise<NotificationCountResponse> => {
  try {
    const response = await api.get<NotificationCountResponse>('/chat/all-notification-count');
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching notification count:', error);
    throw error;
  }
};
